ko.bindingHandlers.asyncMessage = {
  init: function(element, valueAccessor) {
    var $element, options, possible;
    options = {
      validating: 'checking availability...',
      valid: 'available'
    };
    possible = valueAccessor();
    $element = $(element);
    if (ko.isObservable(possible)) {
      $.extend(options, {
        value: possible
      });
    } else {
      $.extend(options, possible);
    }
    $element.addClass('async-message');
    $element.html('<span class=\'validating hide\'>' + ko.unwrap(options.validating) + '</span>' + '<span class=\'valid hide\'>' + ko.unwrap(options.valid) + '</span>');
  },
  update: function(element, valueAccessor) {
    var $element, observable, possible;
    $element = $(element);
    possible = valueAccessor();
    observable = void 0;
    if (ko.isObservable(possible)) {
      observable = possible;
    } else {
      observable = possible.value;
      if (ko.isObservable(possible.validating)) {
        $element.find('.validating').html(possible.validating());
      }
      if (ko.isObservable(possible.valid)) {
        $element.find('.valid').html(possible.valid());
      }
    }
    $element.find('.validating, .valid').hide();
    if (observable.isValidating()) {
      $element.find('.validating').show();
    } else if (observable.isValid()) {
      $element.find('.valid').show();
    }
  }
};
